module.exports = __webpack_public_path__ + "img/mohsen.e7aaa49f.png";